// Email-Validation
export const isValidEmail = (email) => {
  if (!email) return false;
  if (email === '') return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/*
// Optionale zusätzliche Validierungen
export const isValidPhone = (phone) => {
  if (!phone) return true;
  const phoneRegex = /^[\d\s\-+()]+$/;
  return phoneRegex.test(phone);
};

export const isValidZipCode = (zipCode) => {
  if (!zipCode) return true;
  const zipRegex = /^\d{5}$/;
  return zipRegex.test(zipCode);
};
*/